export default __webpack_public_path__ + "static/media/Social-Facebook-Black.d5e18f04.svg";